import React, { useEffect, useState, createContext } from "react";
import DashBoardContainer from "../DashBoardContainer";
import FileUploadProvider from "../../components/context/FileUploadProvider";
import { useSelector } from "react-redux";
import Uploady from "@rpldy/uploady";
import { useNavigate } from "react-router-dom";
export const FileUploadContext = createContext();

const DashboardPage = () => {
  const fileUploadState = useSelector((state) => state.fileUpload);
  const navigate = useNavigate();

  const BASE_URL = process.env.REACT_APP_APIURL;
  const BASE_URL_LIVE = process.env.REACT_APP_APIURL_LIVE;

  const BASE_FPAUPLOADURL = process.env.REACT_APP_FPAUPLOADAPIURL;
  const BASE_FPAUPLOADURL_lIVE = process.env.REACT_APP_FPAUPLOADAPIURL_LIVE;

  const MAIN_URL =
    process.env.REACT_APP_DEV_ENV == "PRODUCTION" ? BASE_URL_LIVE : BASE_URL;
  const MAIN_URL_FPA =
    process.env.REACT_APP_DEV_ENV == "PRODUCTION"
      ? BASE_FPAUPLOADURL_lIVE
      : BASE_FPAUPLOADURL;

  const token = window.localStorage.getItem("USER_ACCESS_TOKEN");

  return (
    <>
      <Uploady
        multiple
        method="POST"
        destination={{
          url:
            fileUploadState.uploadMode == "FPA"
              ? `${MAIN_URL_FPA}pf-image-upload`
              : `${MAIN_URL}album/upload-image`,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }}
        concurrency={3}
      >
        <FileUploadProvider>
          <DashBoardContainer />
        </FileUploadProvider>
      </Uploady>
    </>
  );
};

export default DashboardPage;
